/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { isBrowser } from './environment.js';
import { getAngularVersion, getReactVersion, getVueVersion, getAngularJSVersion } from './framework.js';
import { browserFeatures } from './supports.js';
import { LogService } from '../services/log.service.js';
export function setupCDSGlobal() {
    if (isBrowser()) {
        initializeCDSGlobal();
        setRunningVersion();
        intializeCDSStateProxy();
    }
}
function intializeCDSStateProxy() {
    if (!window.CDS._isStateProxied) {
        window.CDS._isStateProxied = true;
        window.CDS._state = new Proxy(window.CDS._state, {
            set: (target, key, value) => {
                const detail = { key, prev: window.CDS._state[key], current: value };
                target[key] = value;
                document.dispatchEvent(new CustomEvent('CDS_STATE_UPDATE', { detail }));
                return true;
            },
        });
    }
}
function getDetails() {
    return {
        versions: window.CDS._version,
        environment: window.CDS.environment,
        userAgent: navigator.userAgent,
        supports: window.CDS._supports,
        angularVersion: getAngularVersion(false),
        angularJSVersion: getAngularJSVersion(false),
        reactVersion: getReactVersion(false),
        vueVersion: getVueVersion(false),
        state: {
            ...window.CDS._state,
            iconRegistry: Object.keys(window.CDS._state.iconRegistry),
            motionRegistry: Object.keys(window.CDS._state.motionRegistry),
            focusTrapRegistry: Object.keys(window.CDS._state.focusTrapItems.map(i => i.focusTrapId)),
        },
    };
}
function logDetails() {
    LogService.log(JSON.stringify(getDetails(), null, 2));
}
function initializeCDSGlobal() {
    window.CDS = window.CDS || {
        _version: [],
        _react: { version: undefined },
        _supports: browserFeatures.supports,
        _isStateProxied: false,
        _state: {
            focusTrapItems: [],
            i18nRegistry: {},
            elementRegistry: {},
            iconRegistry: {},
            motionRegistry: {},
        },
        environment: {
            production: false,
        },
        getDetails,
        logDetails,
    };
}
function setRunningVersion() {
    var _a;
    const loadedVersion = 'PACKAGE_VERSION';
    if (window.CDS._version.indexOf(loadedVersion) < 0) {
        window.CDS._version.push(loadedVersion);
        (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.setAttribute('cds-version', window.CDS._version.join(' '));
    }
    if (window.CDS._version.length > 1) {
        LogService.warn('Running more than one version of Clarity can cause unexpected issues. Please ensure only one version is loaded.');
    }
}
